import React from "react";
import { List, ListItem, ListItemText, Typography } from "@mui/material";

interface ClinicInfoDisplayProps {
  clinic: {
    id: string;
    BSNR?: string | null;
    businessName: string;
    phone1: string;
    fax: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    zip: string;
    email: string;
    notes: string;
    methodForDrReport: string;
    methodForRxOrder: string;
  };
}

const ClinicInfoDisplay: React.FC<ClinicInfoDisplayProps> = ({ clinic }) => (
  <List>
    <ListItem>
      <ListItemText primary="BSNR" secondary={clinic.BSNR || "-"} />
    </ListItem>
    <ListItem>
      <ListItemText primary="Praxisname" secondary={clinic.businessName || "-"} />
    </ListItem>
    <ListItem>
      <ListItemText primary="Telefon" secondary={clinic.phone1 || "-"} />
    </ListItem>
    <ListItem>
      <ListItemText primary="Fax" secondary={clinic.fax || "-"} />
    </ListItem>
    <ListItem>
      <ListItemText primary="Address Line 1" secondary={clinic.addressLine1 || "-"} />
    </ListItem>
    <ListItem>
      <ListItemText primary="Address Line 2" secondary={clinic.addressLine2 || "-"} />
    </ListItem>
    <ListItem>
      <ListItemText primary="City" secondary={clinic.city || "-"} />
    </ListItem>
    <ListItem>
      <ListItemText primary="Zip" secondary={clinic.zip || "-"} />
    </ListItem>
    <ListItem>
      <ListItemText primary="Email" secondary={clinic.email || "-"} />
    </ListItem>
    <ListItem>
      <ListItemText primary="Hinweise" secondary={clinic.notes || "-"} />
    </ListItem>
    <ListItem>
      <ListItemText primary="Methode für Therapiebericht" secondary={clinic.methodForDrReport || "-"} />
    </ListItem>
    <ListItem>
      <ListItemText primary="Methode für Rezeptbestellung" secondary={clinic.methodForRxOrder || "-"} />
    </ListItem>
  </List>
);

export default ClinicInfoDisplay;
